import gql from 'graphql-tag'

export default gql`mutation createAdminUser($record: CreateOneAdminInput!){
    createAdminUser(record:$record){
      recordId
    }
  }`
